import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { BasicInputTypeEnum } from 'src/shared/enums/basic-input-type.enum';

import { ISchoolStripeSettings } from './../../../interfaces/groups/school.interface';

@Component({
    selector: 'app-school-stripe',
    templateUrl: './school-stripe.component.html',
    styleUrls: ['./school-stripe.component.scss'],
})
export class SchoolStripeComponent {
    @Input() public control: FormGroup;
    @Input() public stripeSettings: ISchoolStripeSettings;

    @Output() public elementSizeModification = new EventEmitter<void>();

    public basicInputTypeEnum = BasicInputTypeEnum;

    public get secretKey(): FormControl {
        return this.control.get('secret_key') as FormControl;
    }
    public get publishableKey(): FormControl {
        return this.control.get('publishable_key') as FormControl;
    }
    public get webhookSigningSecret(): FormControl {
        return this.control.get('webhook_signing_secret') as FormControl;
    }
}
